import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

/**
 * Capture an element by id and export it as a multi-page PDF (A4 portrait).
 * Uses html2canvas with JPEG compression for good quality at reasonable file size.
 * Adds footer to each page.
 */
export async function generateAssessmentPdf(elementId, fileName = 'AI_Readiness_Report.pdf') {
  const element = document.getElementById(elementId);
  if (!element) {
    console.error(`Element #${elementId} not found`);
    return;
  }

  // Ensure the element is visible for capture
  const originalScroll = window.scrollY;
  window.scrollTo(0, 0);

  // Capture element as canvas with good quality
  const canvas = await html2canvas(element, {
    scale: 1.5, // Higher scale for better text rendering (1.5x = good balance)
    useCORS: true,
    logging: false,
    backgroundColor: '#ffffff',
    windowWidth: element.scrollWidth,
    windowHeight: element.scrollHeight
  });

  // Convert to JPEG with high quality for readability
  const imgData = canvas.toDataURL('image/jpeg', 0.92); // 92% quality - readable text
  
  const pdf = new jsPDF({ orientation: 'p', unit: 'pt', format: 'a4' });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  // Calculate image dimensions to fit page
  const ratio = canvas.width / canvas.height;
  const imgWidth = pageWidth;
  const imgHeight = imgWidth / ratio;

  let position = 0;
  let heightLeft = imgHeight;

  // Add first page
  pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
  
  // Add footer to first page
  const addFooter = (pageNum) => {
    const footerY = pageHeight - 40;
    pdf.setFontSize(10);
    pdf.setTextColor('#666666');
    pdf.text('omnigeist.com', pageWidth / 2, footerY, { align: 'center' });
  };
  
  addFooter(1);
  heightLeft -= pageHeight;

  // Add additional pages if content is longer than one page
  let pageNum = 2;
  while (heightLeft > 0) {
    position = heightLeft - imgHeight;
    pdf.addPage();
    pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
    addFooter(pageNum);
    heightLeft -= pageHeight;
    pageNum++;
  }

  pdf.save(fileName);
  window.scrollTo(0, originalScroll);
}
